<template>
  <div class="investment-form">
    <div class="header">
      Dirección <div @click="$emit('openStep')"><span class="mdi mdi-chevron-down"></span></div>
    </div>
    <div class="form">
      <label class="label">
        <div class="label-text">
          Calle y número
        </div>
        <BaseInput v-model="data.address" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Colonia
        </div>
        <BaseInput v-model="data.settlement" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Municipio o alcaldía
        </div>
        <BaseInput v-model="data.municipality" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Estado
        </div>
        <BaseInput v-model="data.state" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          País
        </div>
        <BaseInput v-model="data.country" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Código postal
        </div>
        <BaseInput v-model="data.postalCode" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Teléfono
        </div>
        <BaseInput v-model="data.phone" />
      </label>
    </div>
    <div class="button-wrapper">
      <div class="button" :class="{ disabled: !formFilled }" @click="saveData">
        Siguiente
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BaseInput from '@/components/base/BaseInput.vue';
import { es } from 'vuejs-datepicker/dist/locale';

const { mapState, mapActions } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      data: {},
      es,
      nationalityOptions: [
        { text: 'Mexicana', value: 'mexicana' },
        { text: 'Extranjera', value: 'extranjera' },
      ],
    };
  },
  components: {
    BaseInput,
  },
  watch: {
    user() {
      this.data = { ...this.user };
    },
  },
  computed: {
    formFilled() {
      const fields = ['address', 'settlement', 'municipality', 'state', 'country', 'postalCode', 'phone'];
      for (let i = 0; i < fields.length; i += 1) {
        const key = fields[i];
        if (!this.data[key]) {
          return false;
        }
      }
      return true;
    },
    ...mapState([
      'user',
    ]),
  },
  methods: {
    async saveData() {
      if (this.formFilled) {
        await this.updateUser(this.data);
        this.$emit('next');
      }
    },
    ...mapActions([
      'updateUser',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.investment-form {
  display: flex;
  flex-wrap: wrap;
}
.label {
  width: 100%;
  margin-bottom: 20px;
}
.label--half {
  width: 48%;
}
.label--third {
  width: 30%;
}
.label-text {
  line-height: 18px;
  margin-bottom: 12px;
}
.header {
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
/deep/ .form-input {
  font-size: 15px;
  border: none;
  border: 1px solid #d6d6d8;
  padding: 8px;
  font-family: inherit;
  width: 100%;
  border-radius: 4px;

  &:focus {
    border: 1px solid #3479e9;
  }

}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
.disabled {
  background-color: lighten($color: #3479e9, $amount: 20);
  cursor: not-allowed;
}
</style>
